const colors: Record<string, string> = {
  // Restricted
  '#8847ff': '#9861ff',
  // Classified
  '#d32ce6': '#d63eea',
  // Mil-spec grade
  '#4b69ff': '#617bff',
  //  Covert
  '#eb4b4b': '#ff0000',
  // main
  '#725df8': '#9080f9',
};

export default function (color: string) {
  return colors[color?.toLowerCase()] || color;
}
